(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-buy-buttons"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-add-to-cart]:not([data-init])').forEach(function (btn) {
      btn.setAttribute('data-init', 'true');

      function showError(container, message) {
        var el = container && container.querySelector('[data-add-to-cart-error]');
        if (!el) return;
        el.textContent = message;
        el.removeAttribute('hidden');
      }
      function clearError(container) {
        var el = container && container.querySelector('[data-add-to-cart-error]');
        if (!el) return;
        el.textContent = '';
        el.setAttribute('hidden', '');
      }

      btn.addEventListener('click', function (e) {
        var form = btn.closest('form[action*="/cart/add"]');
        if (!form) return;
        e.preventDefault();
        var container = btn.closest('.product-buy-buttons');
        clearError(container);

        var fd = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { 'Accept': 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (data.status) {
              showError(container, data.description || data.message || 'Could not add to cart. Please try again.');
              return;
            }
            document.dispatchEvent(new CustomEvent('bfoure:cart:changed'));
            document.dispatchEvent(new CustomEvent('bfoure:cart:open'));
          })
          .catch(function () {
            form.submit();
          });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.product-variant-picker:not([data-init])').forEach(function (picker) {
      picker.setAttribute('data-init', 'true');

      var variants = [];
      try { variants = JSON.parse(picker.getAttribute('data-variants') || '[]'); } catch (e) { variants = []; }
      var form = picker.closest('form[action*="/cart/add"]');
      var idInput = form ? form.querySelector('input[name="id"]') : null;

      function selectedOptions() {
        var opts = {};
        picker.querySelectorAll('[data-option-position]').forEach(function (el) {
          var pos = parseInt(el.getAttribute('data-option-position'), 10);
          if (el.tagName === 'SELECT') {
            opts[pos] = el.value;
          } else if (el.type === 'radio' && el.checked) {
            opts[pos] = el.value;
          }
        });
        return opts;
      }

      function syncVariant() {
        if (!idInput || !variants.length) return;
        var sel = selectedOptions();
        var match = variants.find(function (v) {
          if (!v.options || !v.options.length) return false;
          return v.options.every(function (val, i) { return sel[i + 1] === val; });
        });
        if (match) {
          idInput.value = match.id;
          picker.dispatchEvent(new CustomEvent('bfoure:variant:changed', { bubbles: true, detail: { variant: match } }));
        }
      }

      picker.addEventListener('change', function () {
        picker.querySelectorAll('.product-variant-picker__pill, .product-variant-picker__swatch').forEach(function (el) {
          el.classList.remove('product-variant-picker__pill--active', 'product-variant-picker__swatch--active');
        });
        picker.querySelectorAll('input[type="radio"]:checked').forEach(function (radio) {
          var label = radio.closest('label');
          if (label) {
            if (label.classList.contains('product-variant-picker__pill')) label.classList.add('product-variant-picker__pill--active');
            if (label.classList.contains('product-variant-picker__swatch')) label.classList.add('product-variant-picker__swatch--active');
          }
        });
        syncVariant();
      });

      syncVariant();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
